export const Application = {
    Protect: "Protect",
    Insight: "Insight",
    Exchange: "Exchange",
    CCL: "CCL",
    Notify: "Notify"
}